'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Loader2, Wifi } from 'lucide-react'
import { useTranslations } from 'next-intl'

import { Button } from '@/components/ui/button'

interface IpAccessResult {
  granted: boolean
  ip: string
  method: string | null
}

export function IpAccessButton() {
  const router = useRouter()
  const t = useTranslations('login')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function requestIpAccess() {
    setLoading(true)
    setError(null)
    try {
      const res = await fetch('/api/access/ip', { method: 'POST' })
      const data = (await res.json()) as IpAccessResult
      if (data.granted) {
        router.push('/')
        router.refresh()
      } else {
        setError(t('ipNotAllowed', { ip: data.ip }))
      }
    } catch {
      setError(t('ipCheckFailed'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <Button
        type="button"
        variant="outline"
        size="lg"
        className="w-full"
        onClick={requestIpAccess}
        disabled={loading}
      >
        {loading ? <Loader2 className="animate-spin" /> : <Wifi />}
        {t('ipAccess')}
      </Button>
      {error && (
        <p role="alert" className="text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  )
}
